import { render } from "./SessionEdit.vue?vue&type=template&id=68406cb6"
import script from "./SessionEdit.vue?vue&type=script&lang=js"
export * from "./SessionEdit.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__